import { useQuery } from "@apollo/react-hooks";
import { GET_USER_BILLING } from "../api/queries/user";

export default function useUserBilling() {
  return useQuery(GET_USER_BILLING, {
    context: { useAuthedEndpoint: true }
  });
}
